import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { DifficultyLink } from "../Filtering/DifficultyLink"
import { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"
import React from "react"

export interface DifficultyOutcomeTableProps {
	difficulties: number[]
	plays: Play[]
}

export const DifficultyOutcomeTable = React.memo(function (props: DifficultyOutcomeTableProps): JSX.Element {

	const table = 'DifficultyOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'difficulty', ascending: true }

	const rowByDifficulty: Map<number, TableRow> = new Map(
		props.difficulties.map(difficulty => {
			return [
				difficulty,
				{
					difficulty,
					lossCount: null,
					playCount: null,
					winCount: null,
					winRate: null,
				}
			]
		})
	)

	for (const play of props.plays) {
		if (play.difficulty === null) {
			continue
		}

		const row = rowByDifficulty.get(play.difficulty)!

		if (row.lossCount === null) { row.lossCount = 0 }
		if (row.playCount === null) { row.playCount = 0 }
		if (row.winCount === null) { row.winCount = 0 }
		if (row.winRate === null) { row.winRate = 0 }

		if (play.outcome.victory) {
			row.winCount++
		} else {
			row.lossCount++
		}
	}

	const tableData: TableRow[] = []
	for (const difficulty of props.difficulties) {
		const row = rowByDifficulty.get(difficulty)!
		tableData.push(row)
		if (row.playCount === null) {
			continue
		}

		row.playCount = row.winCount! + row.lossCount!
		row.winRate = row.winCount! / row.playCount
	}

	Sorting.sort(tableData, sort, 'difficulty')

	return (
		<div>
			<table className="stats difficulty-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'difficulty'} label='Difficulty' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.difficulty}>
								<th><DifficultyLink difficulty={row.difficulty} /></th>
								<td className={`victory difficulty-${Math.floor(row.difficulty)}`}>{row.playCount ? row.winCount : ''}</td>
								<td className={`loss difficulty-${Math.floor(row.difficulty)}`}>{row.playCount ? row.lossCount : ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
})

interface TableRow {
	difficulty: number
	lossCount: number | null
	playCount: number | null
	winCount: number | null
	winRate: number | null
}
